import { render } from "./DashboardHeaderRight.vue?vue&type=template&id=07715737&scoped=true"
import script from "./DashboardHeaderRight.vue?vue&type=script&lang=js"
export * from "./DashboardHeaderRight.vue?vue&type=script&lang=js"

import "./DashboardHeaderRight.vue?vue&type=style&index=0&id=07715737&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07715737"]])

export default __exports__